// OfficialCard

export default function OfficialCard({ name, position, image }) {
  return (
    <article className="group">
      <div className="aspect-[4/3] overflow-hidden border border-white/10 bg-white/5 transition group-hover:border-amber-flame-500/50">
        {image ? (
          <img
            src={image}
            alt={name}
            className="h-full w-full object-cover grayscale transition duration-500 group-hover:grayscale-0"
          />
        ) : (
          <div className="flex h-full w-full items-center justify-center bg-twilight-indigo-800/60">
            <span className="text-xs font-semibold uppercase tracking-[0.25em] text-slate-500">
              Photo
            </span>
          </div>
        )}
      </div>

      <div className="mt-4 text-center">
        <h3 className="font-serif text-xl font-semibold leading-tight text-white md:text-2xl">
          {name}
        </h3>

        <p className="mt-1 text-[0.65rem] font-semibold uppercase tracking-[0.22em] text-slate-400">
          {position}
        </p>
      </div>
    </article>
  );
}